import { render, staticRenderFns } from "./ImportTest.vue?vue&type=template&id=7ddc398f&"
import script from "./ImportTest.vue?vue&type=script&lang=js&"
export * from "./ImportTest.vue?vue&type=script&lang=js&"
import style0 from "./ImportTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportTest.vue"
export default component.exports